import {
  isEditKeyLocked,
  returnEditLockReason,
  returnEditSecurityKey,
} from "@/components/widgets/tradeFromScratch/helper/blockEditHelper";
import { IDraftLegRow, isDraftLegRow } from "./useDraftLegTicket";

// LQC-3027 - the ticket key each lockable column edits. Security varies by instrument.
export function returnDraftLegColumnKey(colId: string, row: IDraftLegRow): string | undefined {
  if (colId === "CreationDirectionCell") return "direction";
  if (colId === "CreationExternalIDCell") return "transactionNumber";
  if (colId === "CreationSecurityCell") return returnEditSecurityKey(row.instrument);
  return undefined;
}

export function isDraftLegColumnLocked(colId: string, row: IDraftLegRow): boolean {
  const key = returnDraftLegColumnKey(colId, row);
  return !!key && isEditKeyLocked(row.edit, key);
}

// AG Grid tooltip (instant in Trade Creation) for a locked draft cell: FIX, or terms the edit can't see.
export function returnDraftLegLockedTooltip(colId: string, data: unknown): string | undefined {
  if (!isDraftLegRow(data)) return undefined;
  const key = returnDraftLegColumnKey(colId, data);
  return (key && returnEditLockReason(data.edit, key)) || undefined;
}
